import { useSelector } from 'react-redux';
import { selectViewMemberPatches } from './viewMembersUpdatesSelectors';
export const useRealtimeViewMemberUpdates = () => {
  const viewMemberUpdates = useSelector(selectViewMemberPatches);
  return {
    viewMemberUpdates
  };
};